export default __webpack_public_path__ + "static/media/telainicial-microfone.1271266e.png";